import Layout from "@/components/Layout";
import { Wallet } from "lucide-react";
import { PlaceholderPanel } from "@/pages/AdmissionPlaceholder";

export default function FinancePlaceholder() {
  return (
    <Layout>
      <PlaceholderPanel icon={Wallet} title="Finance" subtitle="Coming soon" tone="emerald" testid="finance-placeholder">
        Track fee collections, send payment reminders to parents, manage staff payroll, and export
        the full ledger for your accountant — all from one place.
      </PlaceholderPanel>
    </Layout>
  );
}
